/* =========================================================
   TuchSoft — Blog article page enhancements
   Progressive enhancement on top of the generated article HTML.
   Loaded only on article pages.
   ========================================================= */
(function () {
  var doc = document.documentElement;
  var content = document.querySelector('.blog-content');
  if (!content) return;

  /* ---- tables: wrap for horizontal scroll ------------------- */
  [].forEach.call(content.querySelectorAll('table'), function (t) {
    if (t.parentNode && t.parentNode.classList.contains('table-wrap')) return;
    var w = document.createElement('div');
    w.className = 'table-wrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* ---- "practical takeaway" paragraph -> callout ------------ */
  [].forEach.call(content.querySelectorAll('p'), function (p) {
    var s = p.querySelector(':scope > strong');
    if (s && /^the practical takeaway\s*:?\s*$/i.test(s.textContent.trim())) {
      p.classList.add('callout');
      s.classList.add('callout__label');
      var ico = document.createElement('span');
      ico.className = 'callout__ico';
      ico.setAttribute('aria-hidden', 'true');
      ico.textContent = '\uD83D\uDCA1';
      p.insertBefore(ico, p.firstChild);
    }
  });

  /* ---- reading time + date formatting ----------------------- */
  var rt = document.querySelector('.js-readtime');
  if (rt) {
    var words = (content.textContent || '').trim().split(/\s+/).length;
    rt.textContent = Math.max(1, Math.round(words / 220)) + ' min read';
  }
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];
  [].forEach.call(document.querySelectorAll('.js-date'), function (el) {
    var m = /^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/.exec((el.getAttribute('data-date') || '').trim());
    if (m) el.textContent = (+m[1]) + ' ' + MONTHS[(+m[2]) - 1] + ' ' + m[3];
  });

  /* ---- TOC: rows, collapse toggles, scroll-spy -------------- */
  var toc = document.querySelector('.table-of-contents');
  var heads = [], links = {};
  [].forEach.call(document.querySelectorAll('.blog-content h2, .blog-content h3'), function (h) {
    var a = h.querySelector('.heading-permalink');
    if (a && a.id) heads.push({ id: a.id, el: h });
  });

  if (toc) {
    [].forEach.call(toc.querySelectorAll('li'), function (li) {
      var sub = li.querySelector(':scope > ul');
      var a = li.querySelector(':scope > a');
      if (!a || a.parentNode.classList.contains('toc__row')) return;
      var row = document.createElement('div');
      row.className = 'toc__row';
      li.insertBefore(row, a);
      if (sub) {
        li.classList.add('has-children');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'toc__toggle';
        b.setAttribute('aria-label', 'Toggle section');
        b.setAttribute('aria-expanded', 'true');
        b.addEventListener('click', function (e) {
          e.preventDefault();
          li.classList.toggle('collapsed');
          b.setAttribute('aria-expanded', String(!li.classList.contains('collapsed')));
        });
        row.appendChild(b);
      }
      row.appendChild(a);
    });
    [].forEach.call(toc.querySelectorAll('a[href^="#"]'), function (a) {
      links[a.getAttribute('href').slice(1)] = a;
    });
  }

  /* ---- progress bar + active section ------------------------ */
  var bar = document.getElementById('postProgress');
  var ticking = false;
  function onScroll() {
    if (bar) {
      var h = doc.scrollHeight - doc.clientHeight;
      bar.style.width = (h > 0 ? (doc.scrollTop / h) * 100 : 0) + '%';
    }
    var cur = null;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].el.getBoundingClientRect().top <= 110) cur = heads[i].id;
    }
    for (var id in links) links[id].classList.toggle('is-active', id === cur);
    ticking = false;
  }
  function requestScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll);
  onScroll();

  /* ---- mobile TOC toggle ------------------------------------ */
  var card = document.getElementById('tocCard');
  var head = document.getElementById('tocHead');
  if (card && head) {
    head.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 960px)').matches) card.classList.toggle('open');
    });
  }

  /* ---- back to top ------------------------------------------ */
  [].forEach.call(document.querySelectorAll('[data-totop]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      // NB: global.js redefines window.scrollTo(selector, offset), so use window.scroll.
      if (window.scroll) { window.scroll({ top: 0, behavior: 'smooth' }); }
      else { doc.scrollTop = 0; document.body.scrollTop = 0; }
    });
  });

  /* ---- "Copy for LLM" --------------------------------------- */
  var copyBtn = document.getElementById('copyMd');
  if (copyBtn) {
    var label = copyBtn.querySelector('.tool__label');
    var orig = label ? label.textContent : '';
    var busy = false;
    function flash(text, cls) {
      if (!label) return;
      label.textContent = text;
      copyBtn.classList.add(cls);
      setTimeout(function () { label.textContent = orig; copyBtn.classList.remove(cls); }, 1800);
    }
    function legacyCopy(txt) {
      var ta = document.createElement('textarea');
      ta.value = txt; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.top = '-1000px';
      document.body.appendChild(ta); ta.select();
      var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); return ok;
    }
    copyBtn.addEventListener('click', function () {
      if (busy) return; busy = true;
      fetch(copyBtn.getAttribute('data-md'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (txt) {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(txt).then(function () { return true; },
              function () { return legacyCopy(txt); });
          }
          return Promise.resolve(legacyCopy(txt));
        })
        .then(function (ok) { flash(ok ? 'Copied!' : 'Copy failed', ok ? 'copied' : 'failed'); })
        .catch(function () { flash('Copy failed', 'failed'); })
        .then(function () { busy = false; });
    });
  }
})();
